import template from './loansDetailFinishDeadline.html';
import controller from './loansDetailFinishDeadline.controller';
import './loansDetailFinishDeadline.scss';

let loansDetailFinishDeadlineComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansDetailFinishDeadlineComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailFinishDeadline/loansDetailFinishDeadline.component.js